export function dateDiff(startDate, endDate) {
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;

    let diff = endDate - startDate;
    let days = Math.floor(diff / day);
    let hours = Math.floor((diff % day) / hour);
    let minutes = Math.floor((diff % hour) / minute);
    let seconds = Math.floor((diff % minute) / second);

    return {
        diff: diff,
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}



// WEBPACK FOOTER //
// ./js/common/utils/date.js